import { ReturnProductSchema } from "@redotech/redo-model/draft-return/draft-return-items";
import { ReturnTypeEnum } from "@redotech/redo-model/return";
import * as z from "zod/v4";

export const warmExchangeAgentCaches = {
  name: "warmExchangeAgentCaches" as const,
  input: z.object({
    draftReturnId: z.string(),
    returnProduct: ReturnProductSchema,
    returnType: z.enum(ReturnTypeEnum).optional(),
  }),
  output: z.void(),
};
